export default __webpack_public_path__ + "static/hodler_mobile@2x-fe88eb4a9a356188b0936234efa9682a.png";